import {
	GetContracts,
	Contracts,
	GetContractsRequest,
	GetContractFiles,
	ContractFiles,
	GetContractFilesRequest,
	ContractsInfoResponse,
	PutContractsInfoRequest,
	GetContractsEntryContractsRequest,
	PostContractsEntryContractsRequest,
	GetContractsEntryContractsService,
	GetContractsContractNoRequest,
	GetContractsContractNoResponse,
} from 'supporter';
import {api} from '@/api';
import {ActionContext} from 'vuex';

interface ContractState {
	contracts: GetContracts
	contractFiles: GetContractFiles
	contractEditResponse: ContractsInfoResponse
	contractsEntryContracts: GetContractsEntryContractsService[]
	contractsContractNo: GetContractsContractNoResponse
}

export default {
	namespaced: true,
	state: {
		contracts: {
			contents: [],
			totalCount: 0
		},
		contractFiles: {
			globalDocuments: [],
			domesticDocuments: []
		},
		contractEditResponse: {
			successCount: 0,
			failCount: 0,
			failure: []
		},
		contractsEntryContracts: [
			{
				agreedDateTime: {},
				changeReason: '',
				contents: '',
				createdDateTime: {},
				agreed: false,
			}
		],
		contractsContractNo: {
			startedDateTime: '',
			partnerNo: 0,
			commissionRate: 0,
			merchandiserNo: 0,
			contractStatus: '',
			entryContracts: [],
			contractType: '',
			contractNo: 0,
			promotionAgreed: false,
			createdDateTime: '',
			mallNo: 0,
		}
	},
	getters: {
		contractsInfo(state: ContractState): Contracts[] {
			return state.contracts.contents;
		},
		contractsTotalCount(state: ContractState): number {
			return state.contracts.totalCount
		},
		globalDocuments(state: ContractState): ContractFiles[] {
			return state.contractFiles.globalDocuments
		},
		domesticDocuments(state: ContractState): ContractFiles[] {
			return state.contractFiles.domesticDocuments
		},
		contractsEntryContracts(state: ContractState): GetContractsEntryContractsService[] {
			return state.contractsEntryContracts
		},
		contractsContractNo(state: ContractState): GetContractsContractNoResponse {
			return state.contractsContractNo
		}
	},
	mutations: {
		SET_CONTRACTS(state: ContractState, data: GetContracts): void {
			state.contracts.contents = data.contents;
			state.contracts.totalCount = data.totalCount;
		},
		SET_CONTRACTS_FILES(state: ContractState, data: GetContractFiles): void {
			state.contractFiles.globalDocuments = data.globalDocuments
			state.contractFiles.domesticDocuments = data.domesticDocuments
		},
		SET_CONTRACTS_ENTRY(state: ContractState, data: GetContractsEntryContractsService[]): void {
			state.contractsEntryContracts = data;
		},
		SET_CONTRACTS_CONTRACT_NO(state: ContractState, data: GetContractsContractNoResponse): void {
			state.contractsContractNo = data
		}
	},
	actions: {
		async fetchContracts({commit}: ActionContext<ContractState, any>, payload: GetContractsRequest): Promise<void> {
			const {data} = await api.getContracts(payload);
			commit('SET_CONTRACTS', data)
		},
		async fetchContractFiles({commit}: ActionContext<ContractState, any>, payload: GetContractFilesRequest): Promise<void> {
			const data = await api.getContractsFiles(payload);
			commit('SET_CONTRACTS_FILES', data)
		},
		async putContractsInfo({commit}: ActionContext<ContractState, any>, payload: PutContractsInfoRequest): Promise<void> {
			const data = await api.putContractsInfo(payload);
			// commit('SET_CONTRACT_EDIT_RESPONSE', data)
		},
		async fetchContractsEntryContracts({commit}: ActionContext<ContractState, any>, payload: GetContractsEntryContractsRequest): Promise<void> {
			const data = await api.getContractsEntryContracts(payload);
			commit('SET_CONTRACTS_ENTRY', data)
		},
		async postContractsEntryContracts({commit}: ActionContext<ContractState, any>, payload: PostContractsEntryContractsRequest): Promise<void> {
			await api.postContractsEntryContracts(payload)
		},
		async fetchContractsContractNo({commit}: ActionContext<ContractState, any>, payload: GetContractsContractNoRequest): Promise<void> {
			const {data} = await api.getContractsContractNoRequest(payload)
			commit('SET_CONTRACTS_CONTRACT_NO', data)
		}
	}
}

